<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-10 pt-3 pb-3 bg-fafafa">

                <loader v-if="loaders.reading" />

                <div v-else>

                    <!-- Breadcrumb -->
                    <breadcrumb />

                    <div class="card card-body mb-3">
                        <div class="row">
                            <div class="col-lg-8">
                                <h5 class="font-weight-bold m-0">Modifica informazioni paziente</h5>

                                <p class="text-muted mb-3">
                                    <small>
                                        Le modifiche nei confronti di un paziente sono limitate
                                    </small>
                                </p>
                            </div>
                            <div class="col-lg-4 text-danger text-right" id="decesso">Paziente deceduto</div>
                        </div>    
                        <form @submit.prevent="updatePatient" autocomplete="off" class="mb-3">

                            <div class="row">
                                <div class="col-lg-4">
                                    <div class="form-group">
                                        <label for="CF">Codice fiscale</label>
                                        <input type="text" class="form-control f-family-monospace text-uppercase" id="CF" :value="form.DB.CF" disabled>
                                    </div>
                                </div>
                                <div class="col-lg-4">
                                    <div class="form-group">

                                        <label for="name">Nome</label>
                                        <input type="text" class="form-control text-uppercase" id="name" v-model.trim="$v.form.DB.name.$model" v-bind:class="{'is-invalid': !$v.form.DB.name.required}" disabled>

                                        <div v-if="!$v.form.DB.name.required" class="invalid-feedback">
                                            Nome richiesto
                                        </div>

                                    </div>
                                </div>
                                <div class="col-lg-4">
                                    <div class="form-group">

                                        <label for="surname">Cognome</label>
                                        <input type="text" class="form-control text-uppercase" id="surname" v-model.trim="$v.form.DB.surname.$model" v-bind:class="{'is-invalid': !$v.form.DB.surname.required}" disabled>

                                        <div v-if="!$v.form.DB.surname.required" class="invalid-feedback">
                                            Cognome richiesto
                                        </div>

                                    </div>
                                </div>
                                <div class="col-lg-4">
                                    <div class="form-group">
                                        <label for="date_birth">Data di nascita</label>
                                        <input type="date" class="form-control" id="date_birth" v-model="$v.form.DB.date_birth.$model" disabled>
                                    </div>
                                </div>
                                <div class="col-lg-4">
                                    <div class="form-group">

                                        <label for="sex">Sesso</label>

                                        <select class="form-control" id="sex" v-model.trim="$v.form.DB.sex.$model" disabled>
                                            <option value="M">
                                                UOMO
                                            </option>
                                            <option value="F">
                                                DONNA
                                            </option>
                                        </select>
                                        
                                    </div>
                                </div>
                                <div class="col-lg-4">
                                    <div class="form-group">
                                        <label for="address">Indirizzo</label>
                                        <input type="text" class="form-control" id="address" v-model.trim="$v.form.DB.address.$model">
                                    </div>
                                </div>
                            </div>

                            <p class="font-weight-bold mb-0">Note sul paziente</p>

                            <p class="text-muted mb-3">
                                <small>
                                    Aggiungi delle note e delle informazioni utili nei confronti di questo paziente
                                </small>
                            </p>

                            <div class="form-group">

                                <textarea class="form-control" id="note" rows="3" maxlength="1000" v-model.trim="$v.form.DB.note.$model" v-bind:class="{'is-invalid': !$v.form.DB.note.maxLength || validation.update.patient.ko, 'is-valid': validation.update.patient.ok}"></textarea>

                                <small class="form-text text-muted" v-show="form.DB.note.length > 0">
                                    {{form.DB.note.length}}/1000 Caratteri
                                </small>

                                <div class="invalid-feedback" v-show="!$v.form.DB.note.maxLength">
                                    Le note devono essere inferiori a 1000 caratteri
                                </div>
                                <div class="invalid-feedback" v-show="validation.update.patient.ko">
                                    {{validation.update.patient.ko}}
                                </div>
                                <div class="valid-feedback" v-show="validation.update.patient.ok">
                                    {{validation.update.patient.ok}}
                                </div>

                            </div>

                            <button v-if="!functionDisabled(4, 'update')" class="btn btn-ifo" :disabled="loaders.updating.patient || $v.form.DB.$invalid || !$v.form.DB.$anyDirty">
                                <span v-show="!loaders.updating.patient">Modifica</span>
                                <div v-show="loaders.updating.patient" class="spinner-border spinner-border-sm" role="status"><span class="sr-only">Loading...</span></div>
                            </button>

                        </form>

                        <div class="row">
                            <div class="col-lg-8">
                                <p class="font-weight-bold m-0">Recapiti</p>

                                <p class="text-muted mb-3">
                                    <small>
                                        Il numero di cellulare e l'email vengono utilizzate per l'invio di informazioni al paziente
                                    </small>
                                </p>
                            </div> 
                            <div class="col-lg-4 text-right" v-if="!open_recapiti">
                                <button @click="open_recapiti = true" class="btn btn-ifo w-20">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-list-columns" viewBox="0 0 512 512">
                                        <path d="M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"/>
                                    </svg> 
                                </button>
                            </div>
                            <div class="col-lg-4 text-right" v-if="open_recapiti">
                                <button @click="open_recapiti = false" class="btn btn-ifo w-20">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-list-columns" viewBox="0 0 512 512">
                                        <path d="M233.4 105.4c12.5-12.5 32.8-12.5 45.3 0l192 192c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L256 173.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l192-192z"/>
                                    </svg>
                                </button>
                            </div>                                                       
                        </div>    
                        <div v-if="open_recapiti">

                            <div v-show="validation.ko" class="alert alert-danger">
                                {{validation.ko}}
                            </div>

                            <form @submit.prevent="updatePhone" autocomplete="off" class="mb-3">
                                <div class="row">
                                    <div class="col-lg-4">
                                        <div class="form-group">
                                            <label for="phone">Numero di cellulare</label>
                                            <input type="phone" class="form-control f-family-monospace" id="phone" v-model="form.DB.phone" disabled>
                                        </div>
                                    </div>
                                    <div class="col-lg-4">
                                        <div class="form-group">

                                            <label for="newPhone">Nuovo numero di cellulare</label>
                                            <input type="text" class="form-control" id="newPhone" v-model.trim="$v.form.recapiti.telefonico.phone.$model">

                                            <p v-if="!$v.form.recapiti.telefonico.phone.required && $v.form.recapiti.telefonico.phone.$dirty" class="m-0 text-danger">
                                                <small>Numero di cellulare richiesto</small>
                                            </p>
                                            <p v-if="$v.form.recapiti.telefonico.phone.equalOriginal && $v.form.recapiti.telefonico.phone.$dirty" class="m-0 text-danger">
                                                <small>Numero di cellulare uguale a quello originale</small>
                                            </p>

                                        </div>
                                    </div>
                                    <div class="col-lg-4">
                                        <div class="form-group">

                                            <label for="confirmPhone">Conferma numero di cellulare</label>
                                            <input type="text" class="form-control" id="confirmPhone" v-model.trim="$v.form.confirm.phone.$model">

                                            <p v-if="!$v.form.confirm.phone.required && $v.form.confirm.phone.$dirty" class="m-0 text-danger">
                                                <small>Conferma numero di cellulare richiesto</small>
                                            </p>
                                            <p v-if="!$v.form.confirm.phone.equalsPhone && $v.form.confirm.phone.$dirty" class="m-0 text-danger">
                                                <small>Numeri di cellulare differenti</small>
                                            </p>
                                            
                                        </div>
                                    </div>
                                </div>

                                <button v-if="!functionDisabled(4, 'update')" class="btn btn-ifo" @click="updatePhone" :disabled="(!$v.form.recapiti.telefonico.phone.required || !$v.form.confirm.phone.equalsPhone || $v.form.recapiti.telefonico.phone.equalOriginal) || loaders.updating.phone">
                                    Modifica
                                </button>

                            </form>

                            <form @submit.prevent="updateEmail" autocomplete="off" class="mb-3">
                                <div class="row">
                                    <div class="col-lg-4">
                                        <div class="form-group">
                                            <label for="email">Indirizzo email</label>
                                            <input type="text" class="form-control" id="email" v-model="form.DB.email" disabled>
                                        </div>
                                    </div>
                                    <div class="col-lg-4">
                                        <div class="form-group">

                                            <label for="newEmail">Nuovo indirizzo email</label>
                                            <input type="text" class="form-control" id="newEmail" v-model.trim="$v.form.recapiti.elettronico.email.$model">

                                            <p v-if="!$v.form.recapiti.elettronico.email.required && $v.form.recapiti.elettronico.email.$dirty" class="m-0 text-danger">
                                                <small>Indirizzo email richiesto</small>
                                            </p>
                                            <p v-if="$v.form.recapiti.elettronico.email.equalOriginal && $v.form.recapiti.elettronico.email.$dirty" class="m-0 text-danger">
                                                <small>Indirizzo email uguale a quello originale</small>
                                            </p>

                                        </div>
                                    </div>
                                    <div class="col-lg-4">
                                        <div class="form-group">

                                            <label for="confirmEmail">Conferma indirizzo email</label>
                                            <input type="text" class="form-control" id="confirmEmail" v-model.trim="$v.form.confirm.email.$model">

                                            <p v-if="!$v.form.confirm.email.required && $v.form.confirm.email.$dirty" class="m-0 text-danger">
                                                <small>Conferma indirizzo email richiesto</small>
                                            </p>
                                            <p v-if="!$v.form.confirm.email.equalsEmail && $v.form.confirm.email.$dirty" class="m-0 text-danger">
                                                <small>Indirizzi email differenti</small>
                                            </p>
                                            
                                        </div>
                                    </div>
                                </div>

                                <button v-if="!functionDisabled(4, 'update')" class="btn btn-ifo" @click="updateEmail" :disabled="(!$v.form.recapiti.elettronico.email.required || !$v.form.confirm.email.equalsEmail || $v.form.recapiti.elettronico.email.equalOriginal) || loaders.updating.email">
                                    Modifica
                                </button>

                            </form>

                        </div>
                        <div class="row">
                            <div class="col-lg-8">
                                <p class="font-weight-bold m-0">Caregiver</p>

                                <p class="text-muted mb-3">
                                    <small>
                                        Il numero di cellulare e l'email vengono utilizzate per l'invio di informazioni al paziente
                                    </small>
                                </p>
                            </div>    
                            <div class="col-lg-4 text-right" v-if="!open_caregiver">
                                <button @click="open_caregiver = true" class="btn btn-ifo w-20">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-list-columns" viewBox="0 0 512 512">
                                        <path d="M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"/>
                                    </svg> 
                                </button>
                            </div>
                            <div class="col-lg-4 text-right" v-if="open_caregiver">
                                <button @click="open_caregiver = false" class="btn btn-ifo w-20">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-list-columns" viewBox="0 0 512 512">
                                        <path d="M233.4 105.4c12.5-12.5 32.8-12.5 45.3 0l192 192c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L256 173.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l192-192z"/>
                                    </svg>
                                </button>
                            </div>                                                       
                        </div> 
                        <div v-if="open_caregiver">
                            <div v-show="validation.ko" class="alert alert-danger">
                                {{validation.ko}}
                            </div>

                            <form @submit.prevent="updatePatient" autocomplete="off" class="mb-3">
                                <div class="row">
                                    <div class="col-lg-4">
                                        <div class="form-group">

                                            <label for="namecg">Nome</label>
                                            <input type="text" class="form-control text-uppercase" id="namecg" v-model.trim="$v.form.DB.namecg.$model">
                                        </div>
                                    </div>
                                    <div class="col-lg-4">
                                        <div class="form-group">

                                            <label for="surnamecg">Cognome</label>
                                            <input type="text" class="form-control text-uppercase" id="surnamecg" v-model.trim="$v.form.DB.surnamecg.$model">

                                        </div>
                                    </div>                               
                                </div>
                                <button v-if="!functionDisabled(4, 'update')" class="btn btn-ifo" @click="updatePatient" :disabled="loaders.updating.patient  || $v.form.DB.$invalid || !$v.form.DB.$anyDirty">
                                    Modifica
                                </button>                           
                            </form> 
                            <form @submit.prevent="updatePhoneCG" autocomplete="off" class="mb-3">
                                <div class="row">
                                    <div class="col-lg-4">
                                        <div class="form-group">
                                            <label for="phone">Numero di cellulare</label>
                                            <input type="phone" class="form-control f-family-monospace" id="phonecg" v-model="form.DB.phonecg" disabled>
                                        </div>
                                    </div>
                                    <div class="col-lg-4">
                                        <div class="form-group">

                                            <label for="newPhone">Nuovo numero di cellulare</label>
                                            <input type="text" class="form-control" id="newPhonecg" v-model.trim="$v.form.recapiti.telefonico.phonecg.$model">

                                            <p v-if="$v.form.recapiti.telefonico.phonecg.equalOriginal && $v.form.recapiti.telefonico.phonecg.$dirty" class="m-0 text-danger">
                                                <small>Numero di cellulare uguale a quello originale</small>
                                            </p>

                                        </div>
                                    </div>
                                    <div class="col-lg-4">
                                        <div class="form-group">

                                            <label for="confirmPhone">Conferma numero di cellulare</label>
                                            <input type="text" class="form-control" id="confirmPhonecg" v-model.trim="$v.form.confirm.phonecg.$model">

                                            <p v-if="!$v.form.confirm.phonecg.equalsPhone && $v.form.confirm.phonecg.$dirty" class="m-0 text-danger">
                                                <small>Numeri di cellulare differenti</small>
                                            </p>
                                            
                                        </div>
                                    </div>  
                                
                                </div>

                                <button v-if="!functionDisabled(4, 'update')" class="btn btn-ifo" @click="updatePhoneCG" :disabled="(!$v.form.recapiti.telefonico.phonecg.required || !$v.form.confirm.phonecg.equalsPhone || $v.form.recapiti.telefonico.phonecg.equalOriginal) || loaders.updating.phonecg">
                                    Modifica
                                </button>

                            </form>                        
                            <form @submit.prevent="updateEmailCG" autocomplete="off" class="mb-3">
                                <div class="row">
                                    <div class="col-lg-4">
                                        <div class="form-group">
                                            <label for="emailcg">Indirizzo email</label>
                                            <input type="text" class="form-control" id="emailcg" v-model="form.DB.emailcg" disabled>
                                        </div>
                                    </div>
                                    <div class="col-lg-4">
                                        <div class="form-group">

                                            <label for="newEmail">Nuovo indirizzo email</label>
                                            <input type="text" class="form-control" id="newEmailcg" v-model.trim="$v.form.recapiti.elettronico.emailcg.$model">

                                            <p v-if="$v.form.recapiti.elettronico.emailcg.equalOriginal && $v.form.recapiti.elettronico.emailcg.$dirty" class="m-0 text-danger">
                                                <small>Indirizzo email uguale a quello originale</small>
                                            </p>

                                        </div>
                                    </div>
                                    <div class="col-lg-4">
                                        <div class="form-group">

                                            <label for="confirmEmail">Conferma indirizzo email</label>
                                            <input type="text" class="form-control" id="confirmEmailcg" v-model.trim="$v.form.confirm.emailcg.$model">

                                            <p v-if="!$v.form.confirm.emailcg.equalsEmail && $v.form.confirm.emailcg.$dirty" class="m-0 text-danger">
                                                <small>Indirizzi email differenti</small>
                                            </p>
                                            
                                        </div>
                                    </div>
                                                            
                                </div>

                                <button v-if="!functionDisabled(4, 'update')" class="btn btn-ifo" @click="updateEmailCG" :disabled="(!$v.form.recapiti.elettronico.emailcg.required || !$v.form.confirm.emailcg.equalsEmail || $v.form.recapiti.elettronico.emailcg.equalOriginal) || loaders.updating.emailcg">
                                    Modifica
                                </button>

                            </form> 
                        </div>    
                    </div>
                    
                    <b-tabs content-class="border border-top-0">
                        <b-tab title="Patologie associate" active>
                            <div class="container-fluid">
                                <div class="row">
                                    <div class="col-lg-10 p-3">

                                        <div v-if="patients_pathologies.length < 1" class="alert alert-warning m-0">
                                            Ancora nessuna patologia associata
                                        </div>

                                        <div class="table-responsive m-0" v-else>
                                            <table class="table table-bordered table-hover table-sm">
                                                <thead>
                                                    <tr>
                                                        <th scope="col">
                                                            Patologia
                                                        </th>
                                                        <th scope="col">
                                                            Terapia
                                                        </th>                                                        
                                                        <th scope="col">
                                                            Durata visita (minuti)
                                                        </th>
                                                        <th scope="col">
                                                            Visibilità
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <router-link tag="tr" v-for="patient_pathology of patients_pathologies" :key="patient_pathology.id" :to="`/user/pazienti/modifica/${$route.params.CF}/associazione/patologie/modifica/${patient_pathology.id}`" v-bind:class="{'disabled_invisible': functionDisabled(10, 'read')}" class="hover cursor-pointer">
                                                        <td>
                                                            {{patient_pathology.pathology.title}}
                                                        </td>
                                                        <td>
                                                            {{ patient_pathology.therapy ? patient_pathology.therapy.title : "-"  }}
                                                        </td>                                                       
                                                        <td>
                                                            {{patient_pathology.sessions_duration}}
                                                        </td>
                                                        <td>
                                                            {{patient_pathology.state ? "Visibile" : "Non visibile"}}
                                                        </td>
                                                    </router-link>
                                                </tbody>
                                            </table>
                                        </div>

                                    </div>
                                    <div class="col-lg-2 p-0 border-left">
                                        <ul class="nav flex-column">
                                            <li class="nav-item">
                                                <router-link v-bind:class="{'disabled': functionDisabled(10, 'create')}" :to="`/user/pazienti/modifica/${form.DB.CF}/associazione/patologie/aggiungi`" class="nav-link d-flex align-items-center justify-content-end p-3 a_bg-ifo border-bottom">
                                                    Associa <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-plus-circle ml-2" viewBox="0 0 16 16">
                                                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                                                        <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
                                                    </svg>
                                                </router-link>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </b-tab>
                        <b-tab title="Appuntamenti" v-if="!functionDisabled(1, 'abilitation')">
                            <div class="container-fluid p-3">
                                
                                <div v-show="appointments.length < 1" class="alert alert-warning m-0">
                                    Ancora nessun appuntamento
                                </div>

                                <div class="row">
                                    <div v-for="appointment of appointments" :key="`appointment_${appointment.id}`" div class="col-lg-4">
                                        <div class="card card-body mb-2">
                                            <div class="row">
                                                <div class="col-7">
                                                    <p class="text-uppercase font-weight-bold">
                                                        {{appointment.pathology}}
                                                    </p>
                                                    <p class="m-0 text-truncate">
                                                        <small>
                                                            {{appointment.date | data_slash}} - {{appointment.h_start | data_ora}} / {{appointment.h_end | data_ora}}
                                                        </small>
                                                    </p>
                                                    <p class="m-0 text-truncate">
                                                        <small>
                                                            {{appointment.therapy ? appointment.therapy.title : "Nessuna terapia associata"}}
                                                        </small>
                                                    </p>
                                                    <p class="m-0 text-truncate">
                                                        <small>
                                                            Stanza 
                                                        </small>
                                                        <small :style="`color: ${appointment.rooms.color}`">
                                                            {{appointment.rooms.title}}
                                                        </small>
                                                    </p>
                                                </div>
                                                <div class="col-5 text-right d-flex flex-column justify-content-between">

                                                    <div class="overflow-hidden">
                                                        <div class="w-100 badge badge-primary" v-if="!appointment.totem_presence && !appointment.room_presence && !appointment.appointment_closed && !appointment.patient_pause && (new Date(appointment.date) > new Date())">
                                                            Programmata
                                                        </div>
                                                        <!-- Alert paziente in sala di attesa -->
                                                        <div class="w-100 badge badge-info d-flex justify-content-center align-items-center" v-if="appointment.totem_presence && !appointment.room_presence && !appointment.appointment_closed && !appointment.patient_pause">
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" fill="currentColor" class="bi bi-hourglass-split mr-1" viewBox="0 0 16 16">
                                                                <path d="M2.5 15a.5.5 0 1 1 0-1h1v-1a4.5 4.5 0 0 1 2.557-4.06c.29-.139.443-.377.443-.59v-.7c0-.213-.154-.451-.443-.59A4.5 4.5 0 0 1 3.5 3V2h-1a.5.5 0 0 1 0-1h11a.5.5 0 0 1 0 1h-1v1a4.5 4.5 0 0 1-2.557 4.06c-.29.139-.443.377-.443.59v.7c0 .213.154.451.443.59A4.5 4.5 0 0 1 12.5 13v1h1a.5.5 0 0 1 0 1h-11zm2-13v1c0 .537.12 1.045.337 1.5h6.326c.216-.455.337-.963.337-1.5V2h-7zm3 6.35c0 .701-.478 1.236-1.011 1.492A3.5 3.5 0 0 0 4.5 13s.866-1.299 3-1.48V8.35zm1 0v3.17c2.134.181 3 1.48 3 1.48a3.5 3.5 0 0 0-1.989-3.158C8.978 9.586 8.5 9.052 8.5 8.351z"/>
                                                            </svg> Sala
                                                        </div>
                                                        <!-- Alert paziente in stanza per fare la visita -->
                                                        <div class="w-100 badge badge-danger d-flex justify-content-center align-items-center" v-if="appointment.totem_presence && appointment.room_presence && !appointment.appointment_closed && !appointment.patient_pause">
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" fill="currentColor" class="bi bi-play-circle mr-1" viewBox="0 0 16 16">
                                                                <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                                                                <path d="M6.271 5.055a.5.5 0 0 1 .52.038l3.5 2.5a.5.5 0 0 1 0 .814l-3.5 2.5A.5.5 0 0 1 6 10.5v-5a.5.5 0 0 1 .271-.445z"/>
                                                            </svg> Visita
                                                        </div>
                                                        <div class="w-100 badge badge-warning d-flex justify-content-center align-items-center" v-if="appointment.totem_presence && appointment.room_presence && appointment.patient_pause && !appointment.patient_pause_back && !appointment.appointment_closed">
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" fill="currentColor" class="bi bi-pause-circle mr-1" viewBox="0 0 16 16">
                                                                <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                                                                <path d="M5 6.25a1.25 1.25 0 1 1 2.5 0v3.5a1.25 1.25 0 1 1-2.5 0v-3.5zm3.5 0a1.25 1.25 0 1 1 2.5 0v3.5a1.25 1.25 0 1 1-2.5 0v-3.5z"/>
                                                            </svg> Pausa
                                                        </div>
                                                        <div class="w-100 badge badge-danger d-flex justify-content-center align-items-center effetto-lampeggia-loop" v-if="appointment.totem_presence && appointment.room_presence && appointment.patient_pause && appointment.patient_pause_back && !appointment.appointment_closed">
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" fill="currentColor" class="bi bi-pause-circle mr-1" viewBox="0 0 16 16">
                                                                <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM6.25 5C5.56 5 5 5.56 5 6.25v3.5a1.25 1.25 0 1 0 2.5 0v-3.5C7.5 5.56 6.94 5 6.25 5zm3.5 0c-.69 0-1.25.56-1.25 1.25v3.5a1.25 1.25 0 1 0 2.5 0v-3.5C11 5.56 10.44 5 9.75 5z"/>
                                                            </svg> Pausa/Attesa
                                                        </div>                                                    
                                                        <div class="w-100 badge badge-success" v-if="appointment.totem_presence && appointment.room_presence && appointment.appointment_closed">
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" fill="currentColor" class="bi bi-pause-circle mr-1" viewBox="0 0 16 16">
                                                                <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                                                                <path d="M10.97 4.97a.235.235 0 0 0-.02.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05z"/>
                                                            </svg> Completata
                                                        </div>
                                                        <div class="w-100 badge badge-success" v-if="appointment.therapy_programId">
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" fill="currentColor" class="bi bi-patch-check mr-1" viewBox="0 0 16 16">
                                                                <path fill-rule="evenodd" d="M10.354 6.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7 8.793l2.646-2.647a.5.5 0 0 1 .708 0z"/>
                                                                <path d="m10.273 2.513-.921-.944.715-.698.622.637.89-.011a2.89 2.89 0 0 1 2.924 2.924l-.01.89.636.622a2.89 2.89 0 0 1 0 4.134l-.637.622.011.89a2.89 2.89 0 0 1-2.924 2.924l-.89-.01-.622.636a2.89 2.89 0 0 1-4.134 0l-.622-.637-.89.011a2.89 2.89 0 0 1-2.924-2.924l.01-.89-.636-.622a2.89 2.89 0 0 1 0-4.134l.637-.622-.011-.89a2.89 2.89 0 0 1 2.924-2.924l.89.01.622-.636a2.89 2.89 0 0 1 4.134 0l-.715.698a1.89 1.89 0 0 0-2.704 0l-.92.944-1.32-.016a1.89 1.89 0 0 0-1.911 1.912l.016 1.318-.944.921a1.89 1.89 0 0 0 0 2.704l.944.92-.016 1.32a1.89 1.89 0 0 0 1.912 1.911l1.318-.016.921.944a1.89 1.89 0 0 0 2.704 0l.92-.944 1.32.016a1.89 1.89 0 0 0 1.911-1.912l-.016-1.318.944-.921a1.89 1.89 0 0 0 0-2.704l-.944-.92.016-1.32a1.89 1.89 0 0 0-1.912-1.911l-1.318.016z"/>
                                                            </svg> P. Teraupetico
                                                        </div>
                                                    </div>

                                                    <router-link :disabled="functionDisabled(1, 'read')" tag="button" :to="`/user/agenda/modifica/${appointment.id}`" class="btn btn-ifo btn-sm">
                                                        Gestisci
                                                    </router-link>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </b-tab>
                    </b-tabs>

                    <b-tabs class="mt-2" content-class="border border-top-0">
                        <b-tab v-if="!functionDisabled(16, 'create')" title="Ricetta specialistica" active>
                            <template v-slot:title>               
                                <strong>Ricetta specialistica</strong>                          
                            </template>                            
  
                            <div class="container-fluid">
                                <div class="row">
                                    <div class="col-lg-12 p-3">
                                        <div class="row mb-2">
                                            <div class="col-lg-12 text-right">
                                                <router-link v-bind:class="{'disabled': functionDisabled(16, 'create')}" :to="`/user/pazienti/modifica/${form.DB.CF}/associazione/ricetta_specialistica/aggiungi`" class="p-2 border-bottom btnCreateRicetta ">
                                                    Inserisci nuova ricetta specialistica <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-plus-circle ml-1" viewBox="0 0 16 16">
                                                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                                                        <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
                                                    </svg>
                                                </router-link>     
                                            </div>
                                        </div>
                                        <div v-if="ricette.length < 1" class="alert alert-warning m-0">
                                            Ancora nessuna ricetta
                                        </div>

                                        <div class="table-responsive m-0" v-else>
                                            <table class="table table-bordered table-sm">
                                                <thead>
                                                    <tr>
                                                        <th scope="col">
                                                            ID
                                                        </th>
                                                        <th scope="col">
                                                            NRE
                                                        </th>                                                        
                                                        <th scope="col">
                                                            Problema
                                                        </th>                                                        
                                                        <th scope="col">
                                                            Data inserimento
                                                        </th>
                                                        <th scope="col">
                                                            Medico
                                                        </th>   
                                                        <th scope="col">Stato</th>                                                                                                                    
                                                        <th scope="col">Annulla</th>
                                                        <th scope="col">Ricetta</th>     
                                                        <th scope="col">Clona</th>   
                                                        <th scope="col">Recup</th>                                                                                                                                                                                                                                                                                              
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="ricetta of ricette" :key="ricetta.id"  class="hover cursor-pointer">
                                                        <td class="f-size-0_8-em">
                                                            {{ ricetta.id }}
                                                        </td>
                                                        <td class="f-size-0_8-em">
                                                            {{JSON.parse(ricetta.data_send).length == 1 ? ricetta.nre : "Contiene " + JSON.parse(ricetta.data_send).length + " ricette"}}
                                                        </td>                                                        
                                                        <td>
                                                            <router-link :to="`/user/pazienti/modifica/${$route.params.CF}/associazione/ricetta_specialistica/modifica/${ricetta.id}`" v-bind:class="{'disabled_invisible': functionDisabled(10, 'read')}" class="f-size-0_8-em textGreen">
                                                                <strong>{{ ricetta.diagnosi_codice }} - {{ ricetta.diagnosi_descrizione }}</strong>
                                                            </router-link>
                                                        </td>                                                       
                                                        <td class="f-size-0_8-em">
                                                            {{ ricetta.data_insert | data_full}}
                                                        </td>
                                                        <td class="f-size-0_8-em">
                                                           {{ ricetta.doctorname }}
                                                        </td> 
                                                        <td class="f-size-0_8-em text-center">
                                                            <a href="#" :ref="'tooltipEl-' + ricetta.id" v-if="JSON.parse(ricetta.data_send).length == 1" @click.prevent="handleClick" @mouseenter="handleMouseEnter(ricetta.id)" :title="tooltipMap[ricetta.id] || ''">
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-trash" viewBox="0 0 640 640">
                                                                    <path d="M320 576C461.4 576 576 461.4 576 320C576 178.6 461.4 64 320 64C178.6 64 64 178.6 64 320C64 461.4 178.6 576 320 576zM288 224C288 206.3 302.3 192 320 192C337.7 192 352 206.3 352 224C352 241.7 337.7 256 320 256C302.3 256 288 241.7 288 224zM280 288L328 288C341.3 288 352 298.7 352 312L352 400L360 400C373.3 400 384 410.7 384 424C384 437.3 373.3 448 360 448L280 448C266.7 448 256 437.3 256 424C256 410.7 266.7 400 280 400L304 400L304 336L280 336C266.7 336 256 325.3 256 312C256 298.7 266.7 288 280 288z"/>
                                                                </svg>                                                               
                                                            </a>                                                                                                                                                                                                                                                                                                                                                                                                                                                                              
                                                        </td>       
                                                        <td class="text-center">
                                                            <a href="#" v-if="ricetta.sent == 0 && ricetta.annulla_ricetta == 0" @click="removeRicetta(ricetta.id)" title="Elimina">
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-trash" viewBox="0 0 448 512">
                                                                    <path d="M135.2 17.7C140.6 6.8 151.7 0 163.8 0L284.2 0c12.1 0 23.2 6.8 28.6 17.7L320 32l96 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 96C14.3 96 0 81.7 0 64S14.3 32 32 32l96 0 7.2-14.3zM32 128l384 0 0 320c0 35.3-28.7 64-64 64L96 512c-35.3 0-64-28.7-64-64l0-320zm96 64c-8.8 0-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16s16-7.2 16-16l0-224c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16s16-7.2 16-16l0-224c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16s16-7.2 16-16l0-224c0-8.8-7.2-16-16-16z"/>
                                                                </svg>                                                            
                                                            </a>
                                                            <a href="javascript:void(0)" v-if="ricetta.sent == 1 && ricetta.annulla_ricetta == 0 && JSON.parse(ricetta.data_send).length == 1" ref="loginBtn" @click="toggleLogin('P', ricetta.nre, ricetta.id)" title="Annulla">
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-trash" viewBox="0 0 512 512">
                                                                    <path d="M125.7 160l50.3 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L48 224c-17.7 0-32-14.3-32-32L16 64c0-17.7 14.3-32 32-32s32 14.3 32 32l0 51.2L97.6 97.6c87.5-87.5 229.3-87.5 316.8 0s87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3s-163.8-62.5-226.3 0L125.7 160z"/>
                                                                </svg>                                                                                                                           
                                                            </a>                                                           
                                                        </td>
                                                        <td class="text-center">   
                                                            <a href="#" v-if="ricetta.sent == 1 && ricetta.annulla_ricetta == 0" @click="readRicetta(ricetta.id, $route.params.CF)" title="PDF">
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-trash" viewBox="0 0 512 512">
                                                                    <path d="M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 144-208 0c-35.3 0-64 28.7-64 64l0 144-48 0c-35.3 0-64-28.7-64-64L0 64zm384 64l-128 0L256 0 384 128zM176 352l32 0c30.9 0 56 25.1 56 56s-25.1 56-56 56l-16 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48 0-80c0-8.8 7.2-16 16-16zm32 80c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0 0 48 16 0zm96-80l32 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-32 0c-8.8 0-16-7.2-16-16l0-128c0-8.8 7.2-16 16-16zm32 128c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-16 0 0 96 16 0zm80-112c0-8.8 7.2-16 16-16l48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 32 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64 0-64z"/>
                                                                </svg>
                                                            </a>
                                                        </td>
                                                        <td class="text-center">                                                             
                                                            <a href="#" @click="cloneRicetta(ricetta.id)" title="Clona">
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-trash" viewBox="0 0 512 512">
                                                                    <path d="M288 448L64 448l0-224 64 0 0-64-64 0c-35.3 0-64 28.7-64 64L0 448c0 35.3 28.7 64 64 64l224 0c35.3 0 64-28.7 64-64l0-64-64 0 0 64zm-64-96l224 0c35.3 0 64-28.7 64-64l0-224c0-35.3-28.7-64-64-64L224 0c-35.3 0-64 28.7-64 64l0 224c0 35.3 28.7 64 64 64z"/>
                                                                </svg>
                                                            </a>                   
                                                        </td> 
                                                        <td class="text-center">   
                                                            <button type="button" class="btnSendRecup btn-sm rounded-3" @click="confirmSend(ricetta, 1)" v-if="hasCur(ricetta) && !ricetta.recup && ricetta.sent && ricetta.annulla_ricetta == 0">Invia</button>
                                                            <button type="button" class="btnSendRecupV btn-sm rounded-3" v-if="ricetta.recup && ricetta.annulla_ricetta == 0" @click="openModalViewRecup(ricetta.nre)">Vedi</button>
                                                            <button type="button" class="btnSendRecupA btn-sm rounded-3" v-if="ricetta.recup && ricetta.annulla_ricetta == 1">Annullata</button>
                                                            <!--<a href="#" v-if="hasCur(ricetta) && !ricetta.recup && ricetta.sent" @click="confirmSend(ricetta, 1)" title="Invia a RECUP">
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" fill="currentColor" class="bi bi-trash text-danger" viewBox="0 0 640 640">
                                                                    <path d="M568.4 37.7C578.2 34.2 589 36.7 596.4 44C603.8 51.3 606.2 62.2 602.7 72L424.7 568.9C419.7 582.8 406.6 592 391.9 592C377.7 592 364.9 583.4 359.6 570.3L295.4 412.3C290.9 401.3 292.9 388.7 300.6 379.7L395.1 267.3C400.2 261.2 399.8 252.3 394.2 246.7C388.6 241.1 379.6 240.7 373.6 245.8L261.2 340.1C252.1 347.7 239.6 349.7 228.6 345.3L70.1 280.8C57 275.5 48.4 262.7 48.4 248.5C48.4 233.8 57.6 220.7 71.5 215.7L568.4 37.7z"/>
                                                                </svg>
                                                            </a>

                                                            <svg v-if="ricetta.recup" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-trash text-success" viewBox="0 0 640 640" title="Ricetta inviata">
                                                                <path d="M530.8 134.1C545.1 144.5 548.3 164.5 537.9 178.8L281.9 530.8C276.4 538.4 267.9 543.1 258.5 543.9C249.1 544.7 240 541.2 233.4 534.6L105.4 406.6C92.9 394.1 92.9 373.8 105.4 361.3C117.9 348.8 138.2 348.8 150.7 361.3L252.2 462.8L486.2 141.1C496.6 126.8 516.6 123.6 530.9 134z"/>
                                                            </svg>-->                                         
                 
                                                        </td>                                                                                                                                                                                                                                                                                        
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </b-tab>  
                        
                        <b-tab v-if="!functionDisabled(17, 'create')" title="Ricetta farmaceutica">
                            <template v-slot:title>                
                                <strong>Ricetta farmaceutica</strong>                          
                            </template>                            
  
                            <div class="container-fluid">
                                <div class="row">
                                    <div class="col-lg-12 p-3">
                                        <div class="row mb-2">
                                            <div class="col-lg-12 text-right">
                                                <router-link  v-bind:class="{'disabled': functionDisabled(16, 'create')}" :to="`/user/pazienti/modifica/${form.DB.CF}/associazione/ricetta_farmaceutica/aggiungi`" class="p-2 border-bottom btnCreateRicetta ">
                                                    Inserisci nuova ricetta farmaceutica <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-plus-circle ml-1" viewBox="0 0 16 16">
                                                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                                                        <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
                                                    </svg>
                                                </router-link>     
                                            </div>
                                        </div>
                                        <div v-if="ricette_farmaceutiche.length < 1" class="alert alert-warning m-0">
                                            Ancora nessuna ricetta
                                        </div>

                                        <div class="table-responsive m-0" v-else>
                                            <table class="table table-bordered table-sm">
                                                <thead>
                                                    <tr>
                                                        <th scope="col">
                                                            ID
                                                        </th>
                                                        <th scope="col">
                                                            NRE
                                                        </th>                                                        
                                                        <th scope="col">
                                                            Problema
                                                        </th>                                                        
                                                        <th scope="col">
                                                            Data inserimento
                                                        </th>
                                                        <th scope="col">
                                                            Medico
                                                        </th>   
                                                        <th scope="col">Stato</th>                                                                                                                    
                                                        <th scope="col">Annulla</th>
                                                        <th scope="col">Ricetta</th>     
                                                        <th scope="col">Clona</th>   
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="ricetta of ricette_farmaceutiche" :key="ricetta.id"  class="hover cursor-pointer">
                                                        <td class="f-size-0_8-em">
                                                            {{ ricetta.id }}
                                                        </td>
                                                        <td class="f-size-0_8-em">
                                                            {{JSON.parse(ricetta.data_send).length == 1 ? ricetta.nre : "Contiene " + JSON.parse(ricetta.data_send).length + " ricette"}}
                                                        </td>                                                        
                                                        <td>
                                                            <router-link :to="`/user/pazienti/modifica/${$route.params.CF}/associazione/ricetta_farmaceutica/modifica/${ricetta.id}`" v-bind:class="{'disabled_invisible': functionDisabled(10, 'read')}" class="f-size-0_8-em textGreen">
                                                                <strong>{{ ricetta.diagnosi_codice }} - {{ ricetta.diagnosi_descrizione }}</strong>
                                                            </router-link>
                                                        </td>                                                       
                                                        <td class="f-size-0_8-em">
                                                            {{ ricetta.data_insert | data_full}}
                                                        </td>
                                                        <td class="f-size-0_8-em">
                                                           {{ ricetta.doctorname }}
                                                        </td> 
                                                        <td class="f-size-0_8-em text-center">
                                                            <a href="#" :ref="'tooltipEl-' + ricetta.id" v-if="JSON.parse(ricetta.data_send).length == 1" @click.prevent="handleClick" @mouseenter="handleMouseEnterF(ricetta.id)" :title="tooltipMap[ricetta.id] || ''">
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-trash" viewBox="0 0 640 640">
                                                                    <path d="M320 576C461.4 576 576 461.4 576 320C576 178.6 461.4 64 320 64C178.6 64 64 178.6 64 320C64 461.4 178.6 576 320 576zM288 224C288 206.3 302.3 192 320 192C337.7 192 352 206.3 352 224C352 241.7 337.7 256 320 256C302.3 256 288 241.7 288 224zM280 288L328 288C341.3 288 352 298.7 352 312L352 400L360 400C373.3 400 384 410.7 384 424C384 437.3 373.3 448 360 448L280 448C266.7 448 256 437.3 256 424C256 410.7 266.7 400 280 400L304 400L304 336L280 336C266.7 336 256 325.3 256 312C256 298.7 266.7 288 280 288z"/>
                                                                </svg>       
                                                            </a>                                                                                                                                                                                                                                                                                                                                                                                                                                                                              
                                                        </td>       
                                                        <td class="text-center">
                                                            <a href="#" v-if="ricetta.sent == 0" @click="removeRicettaF(ricetta.id)" title="Elimina">
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-trash" viewBox="0 0 448 512">
                                                                    <path d="M135.2 17.7C140.6 6.8 151.7 0 163.8 0L284.2 0c12.1 0 23.2 6.8 28.6 17.7L320 32l96 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 96C14.3 96 0 81.7 0 64S14.3 32 32 32l96 0 7.2-14.3zM32 128l384 0 0 320c0 35.3-28.7 64-64 64L96 512c-35.3 0-64-28.7-64-64l0-320zm96 64c-8.8 0-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16s16-7.2 16-16l0-224c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16s16-7.2 16-16l0-224c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16s16-7.2 16-16l0-224c0-8.8-7.2-16-16-16z"/>
                                                                </svg>                                                            
                                                            </a>
                                                            <a href="javascript:void(0)" v-if="ricetta.sent == 1 && JSON.parse(ricetta.data_send).length == 1" ref="loginBtn" @click="toggleLogin('F', ricetta.nre, ricetta.id)" title="Annulla">
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-trash" viewBox="0 0 512 512">
                                                                    <path d="M125.7 160l50.3 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L48 224c-17.7 0-32-14.3-32-32L16 64c0-17.7 14.3-32 32-32s32 14.3 32 32l0 51.2L97.6 97.6c87.5-87.5 229.3-87.5 316.8 0s87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3s-163.8-62.5-226.3 0L125.7 160z"/>
                                                                </svg>                                                                                                                           
                                                            </a>                                                           
                                                        </td>
                                                        <td class="text-center">   
                                                            <a href="#" v-if="ricetta.sent == 1" @click="readRicettaF(ricetta.id, $route.params.CF)" title="PDF">
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-trash" viewBox="0 0 512 512">
                                                                    <path d="M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 144-208 0c-35.3 0-64 28.7-64 64l0 144-48 0c-35.3 0-64-28.7-64-64L0 64zm384 64l-128 0L256 0 384 128zM176 352l32 0c30.9 0 56 25.1 56 56s-25.1 56-56 56l-16 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48 0-80c0-8.8 7.2-16 16-16zm32 80c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0 0 48 16 0zm96-80l32 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-32 0c-8.8 0-16-7.2-16-16l0-128c0-8.8 7.2-16 16-16zm32 128c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-16 0 0 96 16 0zm80-112c0-8.8 7.2-16 16-16l48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 32 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64 0-64z"/>
                                                                </svg>
                                                            </a>
                                                        </td>
                                                        <td class="text-center">                                                             
                                                            <a href="#" @click="cloneRicettaF(ricetta.id)" title="Clona">
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-trash" viewBox="0 0 512 512">
                                                                    <path d="M288 448L64 448l0-224 64 0 0-64-64 0c-35.3 0-64 28.7-64 64L0 448c0 35.3 28.7 64 64 64l224 0c35.3 0 64-28.7 64-64l0-64-64 0 0 64zm-64-96l224 0c35.3 0 64-28.7 64-64l0-224c0-35.3-28.7-64-64-64L224 0c-35.3 0-64 28.7-64 64l0 224c0 35.3 28.7 64 64 64z"/>
                                                                </svg>
                                                            </a>                   
                                                        </td>
                                                        <!--<td class="text-center">  
                                                            <a href="#" v-if="!ricetta.recup && ricetta.sent" @click="confirmSend(ricetta, 2)" title="Invia a RECUP">
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" fill="currentColor" class="bi bi-trash text-danger" viewBox="0 0 640 640">
                                                                    <path d="M568.4 37.7C578.2 34.2 589 36.7 596.4 44C603.8 51.3 606.2 62.2 602.7 72L424.7 568.9C419.7 582.8 406.6 592 391.9 592C377.7 592 364.9 583.4 359.6 570.3L295.4 412.3C290.9 401.3 292.9 388.7 300.6 379.7L395.1 267.3C400.2 261.2 399.8 252.3 394.2 246.7C388.6 241.1 379.6 240.7 373.6 245.8L261.2 340.1C252.1 347.7 239.6 349.7 228.6 345.3L70.1 280.8C57 275.5 48.4 262.7 48.4 248.5C48.4 233.8 57.6 220.7 71.5 215.7L568.4 37.7z"/>
                                                                </svg>
                                                            </a>

                                                            <svg v-if="ricetta.recup" xmlns="http://www.w3.org/2000/svg" width="13" height="13" fill="currentColor" class="bi bi-trash text-success" viewBox="0 0 640 640">
                                                                <path d="M232 88C232 57.1 257.1 32 288 32C318.9 32 344 57.1 344 88L344 215.3L422 286.8C352.7 315.8 304 384.2 304 464C304 513.3 322.6 558.3 353.1 592.3L288 576L179.9 603C169.8 605.5 160 597.9 160 587.5L160 567.7C160 562.8 162.2 558.2 166 555.2L232 502.4L232 402.7L69.1 457C58.7 460.4 48 452.7 48 441.8L48 398.1C48 389.1 51.8 380.6 58.4 374.5L232 215.3L232 88zM352 464C352 384.5 416.5 320 496 320C575.5 320 640 384.5 640 464C640 543.5 575.5 608 496 608C416.5 608 352 543.5 352 464zM553.4 403.1C546.3 397.9 536.2 399.5 531 406.6L478 479.5L451.2 452.7C445 446.5 434.8 446.5 428.6 452.7C422.4 458.9 422.4 469.1 428.6 475.3L468.6 515.3C471.9 518.6 476.5 520.3 481.2 519.9C485.9 519.5 490.1 517.1 492.9 513.4L556.9 425.4C562.1 418.3 560.5 408.2 553.4 403.1z"/>
                                                            </svg> 
                                                        </td>-->                                                                                                                                                                                                                                                                                         
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </b-tab>                        

                    </b-tabs>                    

                </div>
                <div v-if="showPopup" class="popup-overlay">
                    <div class="popup-box">
                        <p>Sei sicuro di voler inviare questa ricetta al Recup?</p>
                        <div class="row">
                            <div class="col-4 pr-0">
                                <button @click="okSendRecup" class="btn btn-ifo btn-block btn-sm rounded-0">Conferma</button>
                            </div>   
                            <div class="col-4 pr-0">
                                <button @click="koSendRecup" class="btn btn-ifo btn-block btn-sm rounded-0">Annulla</button>
                            </div>     
                        </div>
                    </div>    
                </div>
            </div>
            <div class="col-2 h-min-100-calc-lg_logged border-left p-0">
                <ul class="nav flex-column">
                    <li class="nav-item">
                        <a @click="suspendPatient" class="nav-link d-flex align-items-center justify-content-end p-3 a_bg-ifo border-bottom" v-bind:class="{'disabled': loaders.suspending || functionDisabled(4, 'update')}">
                            <span v-show="!loaders.suspending && form.DB.state">
                                Rendi non visibile <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-pause-circle ml-2" viewBox="0 0 16 16">
                                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                                    <path d="M5 6.25a1.25 1.25 0 1 1 2.5 0v3.5a1.25 1.25 0 1 1-2.5 0v-3.5zm3.5 0a1.25 1.25 0 1 1 2.5 0v3.5a1.25 1.25 0 1 1-2.5 0v-3.5z"/>
                                </svg>
                            </span>
                            <span v-show="!loaders.suspending && !form.DB.state">
                                Rendi visibile <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-play-circle ml-2" viewBox="0 0 16 16">
                                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                                    <path d="M6.271 5.055a.5.5 0 0 1 .52.038l3.5 2.5a.5.5 0 0 1 0 .814l-3.5 2.5A.5.5 0 0 1 6 10.5v-5a.5.5 0 0 1 .271-.445z"/>
                                </svg>
                            </span>
                            <div v-show="loaders.suspending" class="spinner-border spinner-border-sm" role="status"><span class="sr-only">Loading...</span></div>
                        </a>
                    </li>
                    <li class="nav-item">
                        <a v-b-toggle.elimina v-bind:class="{'disabled': loaders.deleting || functionDisabled(4, 'delete')}" class="nav-link d-flex align-items-center justify-content-center justify-content-md-end p-3 a_bg-ifo border-bottom">
                            <span class="d-none d-md-block">Elimina</span> <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-trash ml-md-2 mt-md-1" viewBox="0 0 16 16">
                                <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"/>
                                <path fill-rule="evenodd" d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"/>
                            </svg>
                        </a>
                        <b-collapse id="elimina">

                            <div class="alert alert-danger m-0">
                                Sicuro di voler eliminare questo paziente?
                            </div>

                            <div class="row">
                                <div class="col-6 pr-0">
                                    <button @click="delete_patient" class="btn btn-ifo btn-block btn-sm rounded-0" :disabled="loaders.deleting">
                                    
                                        <span v-show="!loaders.deleting">
                                            Si
                                        </span>

                                        <div v-show="loaders.deleting" class="spinner-border spinner-border-sm" role="status"><span class="sr-only">Loading...</span></div>

                                    </button>
                                </div>
                                <div class="col-6 pl-0">
                                    <button v-b-toggle.elimina class="btn btn-ifo btn-block btn-sm rounded-0">No</button>
                                </div>
                            </div>

                        </b-collapse>
                    </li>                                
                </ul>
            </div>
            <div v-if="showLogin" class="login-popup" ref="loginPopup" :style="{ top: `${popupPosition.top}px`, left: `${popupPosition.left}px` }">
                <div>
                    <input type="text" v-model="username" placeholder="Username" />
                    <br />
                    <input type="password" v-model="password" placeholder="Password" class="mt-2" />

                    <label class="mt-2">
                        <input type="checkbox" v-model="rememberMe" />
                        Ricordami
                    </label>
                    <br />
                    <button @click="submitLogin" class="btn btn-ifo mt-2">Annulla ricetta</button>
                    <button @click="toggleLogin('', '', '')" class="btn btn-ifo mt-2 ml-3">Chiudi</button>
                </div>    
            </div>             
        </div>
        <b-modal id="modal_view_recup" ref="modalViewRecup" size="lg" hide-footer hide-header centered>
            
            <div v-if="jsonRecup">
                <JsonViewer :data="jsonRecup" />
            </div>
            <div v-else>
                Caricamento...
            </div>

        </b-modal>

        <!-- Ricetta PDF -->
        <vue-html2pdf

            :show-layout="false"
            :enable-download="false"
            :preview-modal="true"
            :manual-pagination="false"
            :pdf-quality="2"
            filename="ricetta"
            pdf-format="a4"
            pdf-orientation="portrait"
            pdf-content-width="100%"            
            :html-to-pdf-options = "pdf.config"
            ref = "html2PdfRicetta"

        >
            <section slot="pdf-content" class="f-size_PDF">
                <div v-for="(ricetta, index) in parsedDataRicetta" :key="index" class="pdf-container-ricetta" :class="{ 'page-break': index !== parsedDataRicetta.length - 1 }">
                    <div class="header-ricetta">
                        <div class="title-ricetta">SERVIZIO SANITARIO NAZIONALE</div>
                        <div class="title-ricetta-2">RICETTA ELETTRONICA – PROMEMORIA PER L’ASSISTITO</div>
                    </div>

                    <table class="main-table-ricetta">
                        <tr>
                            <td class="box-wide-ricetta" colspan="2">Lazio</td>
                            <td class="box-wide-ricetta-2" colspan="2">
                                <div class="text-danger">{{ ricetta.header[0].errore }}</div>
                                <div v-if="ricetta.header[0].statoProcesso == 4 || ricetta.header[0].statoProcesso == 9" class="text-danger">{{ ricetta.header[0].annullaText }}</div>
                                <NreBarcode :nre="ricetta.header[0].nre" />
                            </td>
                        </tr>
                        <tr>
                            <td class="box-patient-data mb-2 f-size-0_8-em" colspan="3">
                                COGNOME E NOME /INIZIALI DELL’ASSISTITO: {{ ricetta.header[0].oscuramento_dati == 1 ? `DATI DELL’ASSISTITO OSCURATI AI SENSI DELL’ARTICOLO 87 DEL DL 30 giugno 2003, n. 196` : ricetta_data_pdf.patient.name }}
                                <table v-if="ricetta.header[0].oscuramento_dati == 0">
                                    <tr>
                                        <td class="box-patient-data f-size-0_8-em">INDIRIZZO: {{ ricetta_data_pdf.patient.address }}</td>
                                        <td class="box-patient-data f-size-0_8-em" >CAP: {{ ricetta_data_pdf.patient.cap }}</td>
                                        <td class="box-patient-data f-size-0_8-em" >CITTÀ: {{ ricetta_data_pdf.patient.city }}</td>
                                        <td class="box-patient-data f-size-0_8-em">PROV: {{ ricetta_data_pdf.patient.province }}</td>
                                    </tr>                                    
                                </table>
                            </td>
                            <td class="box-patient-data-2" >
                                <FiscalCodeBarcode :fiscalCode="ricetta.header[0].CF" />
                            </td>
                        </tr>
                        <tr class="hr-ricetta">
                            <td class="box-patient-data f-size-0_8-em width-col-ricetta-4" colspan="4">
                                ESENZIONE: {{ ricetta.data[0].codice_esenzione ? filters.split_(ricetta.data[0].codice_esenzione, '@') : "" }}
                                &nbsp;&nbsp;
                                SIGLA PROVINCIA: RM
                                &nbsp;&nbsp;
                                CODICE ASL: 908
                                &nbsp;&nbsp;
                                DISPOSIZIONI REGIONALI: 
                            </td>

                        </tr>
                        <tr>
                            <td class="box-patient-data f-size-0_8-em width-col-ricetta-4"  colspan="4">
                                TIPOLOGIA PRESCRIZIONE(S,H): {{ ricetta_data_pdf.prescriptionInfo.type }}
                                &nbsp;&nbsp;
                                ALTRO: {{ ricetta_data_pdf.prescriptionInfo.altro }}
                                &nbsp;&nbsp;
                                PRIORITÀ PRESCRIZIONE(U,B,D,P): {{ ricetta.data[0].priorita.slice(0, 1) != 0 ? ricetta.data[0].priorita.slice(0, 1) : "" }}
                            </td>
                        </tr>
                    </table>

                    <table class="prescription-table-ricetta">
                        <thead>
                            <tr>
                                <th colspan="2" class="left-align-ricetta"><span>PRESCRIZIONE</span></th>
                                <th class="center-align-ricetta"><span>QTA</span></th>
                                <th class="center-align-ricetta"><span>NOTA</span></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(prestazione, i) in ricetta.data" :key="i">
                            <!--<tr v-for="(item, index) in ricetta_data_pdf.prescriptions" :key="index">-->
                                <td colspan="2" class="left-align-ricetta f-size-0_8-em p-2">{{ prestazione.codice_prestazione }} ( {{ prestazione.codice_cur }} ) {{ prestazione.descrizione_prestazione }}</td>
                                <td class="center-align-ricetta f-size-0_8-em p-2">{{ prestazione.quantita }}</td>
                                <td class="center-align-ricetta f-size-0_8-em p-2">{{ prestazione.note }}</td>
                            </tr>                           
                        </tbody>
                    </table>

                    <div class="footer-ricetta f-size-0_8-em">
                        QUESITO DIAGNOSTICO: {{  filters.split_(ricetta.header[0].codice, '@') }} - {{  filters.split__(ricetta.header[0].codice, '@') }}<br />
                        N.CONFEZIONI/PRESTAZIONI: {{ ricetta.data.length }}
                        &nbsp;&nbsp; TIPO RICETTA: {{  ricetta.header[0].tipo_ricetta ? ricetta.header[0].tipo_ricetta : "SSN" }} 
                        &nbsp;&nbsp; DATA: {{ ricetta.header[0].data_nre | data_slash }}
                        &nbsp;&nbsp; CODICE FISCALE DEL MEDICO: {{ ricetta_data_pdf.doctor.cf }}<br />
                        CODICE AUTENTICAZIONE: {{ ricetta.header[0].codAutenticazione }}
                        &nbsp;&nbsp; COGNOME E NOME DEL MEDICO: {{ ricetta_data_pdf.doctor.name }}<br />

                        <p class="note-ricetta f-size-0_8-em mt-1 text-center">
                            Rilasciato ai sensi dell’art.11, comma 16 del DL 31 mag 2010,n.78 e dell’art.1, comma 4 del DM 2 nov 2011
                        </p>                                 
                    </div>
                </div>
            </section>
        </vue-html2pdf>  
        <vue-html2pdf

            :show-layout="false"
            :enable-download="false"
            :preview-modal="true"
            :manual-pagination="false"
            :pdf-quality="2"
            filename="ricetta"
            pdf-format="a4"
            pdf-orientation="portrait"
            pdf-content-width="100%"            
            :html-to-pdf-options = "pdf.config"
            ref = "html2PdfRicettaF"

        >
            <section slot="pdf-content" class="f-size_PDF">
                <div v-for="(ricetta, index) in parsedDataRicettaF" :key="index" class="pdf-container-ricetta" :class="{ 'page-break': index !== parsedDataRicettaF.length - 1 }">
                    <div class="header-ricetta">
                        <div class="title-ricetta">SERVIZIO SANITARIO NAZIONALE</div>
                        <div class="title-ricetta-2">RICETTA ELETTRONICA – PROMEMORIA PER L’ASSISTITO</div>
                    </div>

                    <table class="main-table-ricetta">
                        <tr>
                            <td class="box-wide-ricetta" colspan="2">Lazio</td>
                            <td class="box-wide-ricetta-2" colspan="2">
                                <div class="text-danger">{{ ricetta.header[0].errore }}</div>
                                <div v-if="ricetta.header[0].statoProcesso == 4 || ricetta.header[0].statoProcesso == 9" class="text-danger">{{ ricetta.header[0].annullaText }}</div>
                                <NreBarcode :nre="ricetta.header[0].nre" />
                            </td>
                        </tr>
                        <tr>
                            <td class="box-patient-data mb-2 f-size-0_8-em" colspan="3">
                                COGNOME E NOME /INIZIALI DELL’ASSISTITO: {{ ricetta.header[0].oscuramento_dati == 1 ? `DATI DELL’ASSISTITO OSCURATI AI SENSI DELL’ARTICOLO 87 DEL DL 30 giugno 2003, n. 196` : ricetta_data_pdf.patient.name }}
                                <table v-if="ricetta.header[0].oscuramento_dati == 0">
                                    <tr>
                                        <td class="box-patient-data f-size-0_8-em">INDIRIZZO: {{ ricetta_data_pdf.patient.address }}</td>
                                        <td class="box-patient-data f-size-0_8-em" >CAP: {{ ricetta_data_pdf.patient.cap }}</td>
                                        <td class="box-patient-data f-size-0_8-em" >CITTÀ: {{ ricetta_data_pdf.patient.city }}</td>
                                        <td class="box-patient-data f-size-0_8-em">PROV: {{ ricetta_data_pdf.patient.province }}</td>
                                    </tr>                                    
                                </table>
                            </td>
                            <td class="box-patient-data-2" >
                                <FiscalCodeBarcode :fiscalCode="ricetta.header[0].CF" />
                            </td>
                        </tr>
                        <tr class="hr-ricetta">
                            <td class="box-patient-data f-size-0_8-em width-col-ricetta-4" colspan="4">
                                ESENZIONE: {{ ricetta.data[0].codice_esenzione ? filters.split_(ricetta.data[0].codice_esenzione, '@') : "" }}
                                &nbsp;&nbsp;
                                SIGLA PROVINCIA: RM
                                &nbsp;&nbsp;
                                CODICE ASL: 908
                                &nbsp;&nbsp;
                                DISPOSIZIONI REGIONALI: 
                            </td>

                        </tr>
                        <tr>
                            <td class="box-patient-data f-size-0_8-em width-col-ricetta-4"  colspan="4">
                                TIPOLOGIA PRESCRIZIONE(S,H): 
                                &nbsp;&nbsp;
                                ALTRO: 
                                &nbsp;&nbsp;
                                PRIORITÀ PRESCRIZIONE(U,B,D,P): 
                            </td>
                        </tr>
                    </table>

                    <table class="prescription-table-ricetta">
                        <thead>
                            <tr>
                                <th colspan="2" class="left-align-ricetta"><span>PRESCRIZIONE</span></th>
                                <th class="center-align-ricetta"><span>QTA</span></th>
                                <th class="center-align-ricetta"><span>NOTA</span></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(prestazione, i) in ricetta.data" :key="i">
                            <!--<tr v-for="(item, index) in ricetta_data_pdf.prescriptions" :key="index">-->
                                <td colspan="2" class="left-align-ricetta f-size-0_8-em p-2">{{ prestazione.codice_prestazione }} {{ prestazione.descrizione_prestazione }}</td>
                                <td class="center-align-ricetta f-size-0_8-em p-2">{{ prestazione.quantita }}</td>
                                <td class="center-align-ricetta f-size-0_8-em p-2">--</td>
                            </tr>                           
                        </tbody>
                    </table>

                    <div class="footer-ricetta f-size-0_8-em">
                        QUESITO DIAGNOSTICO: {{  filters.split_(ricetta.header[0].codice, '@') }} - {{  filters.split__(ricetta.header[0].codice, '@') }}<br />
                        N. PRESTAZIONI: {{ ricetta.data.length }}
                        &nbsp;&nbsp; TIPO RICETTA: {{  ricetta.header[0].tipo_ricetta ? ricetta.header[0].tipo_ricetta : "SSN" }} 
                        &nbsp;&nbsp; DATA: {{ ricetta.header[0].data_nre | data_slash }}
                        &nbsp;&nbsp; CODICE FISCALE DEL MEDICO: {{ ricetta_data_pdf.doctor.cf }}<br />
                        CODICE AUTENTICAZIONE: {{ ricetta.header[0].codAutenticazione }}
                        &nbsp;&nbsp; COGNOME E NOME DEL MEDICO: {{ ricetta_data_pdf.doctor.name }}<br />

                        <p class="note-ricetta f-size-0_8-em mt-1 text-center">
                            Rilasciato ai sensi dell’art.11, comma 16 del DL 31 mag 2010,n.78 e dell’art.1, comma 4 del DM 2 nov 2011
                        </p>                                 
                    </div>
                </div>
            </section>
        </vue-html2pdf>           
    </div> 
</template>

<script>

    import { 
        required,
        maxLength
    } from "vuelidate/lib/validators"

    import moment from "moment"
    import store  from "@/store"
    import VueHtml2pdf from 'vue-html2pdf'
    import NreBarcode from "@/components/NreBarcode.vue";
    import FiscalCodeBarcode from "@/components/FiscalCodeBarcode.vue";
    import JsonViewer from "@/components/JsonViewer.vue";

    export default {
        data() {
            return {  
                jsonRecup: {},
                currentNre: null,
                curTargets: ["89.03_5", "96.59_0", "99.21_0", "99.23_3", "99.25_0"],
                showPopup: false,
                typeRicetta: 1,
                ricettaObj: null,
                popupPosition: { top: 0, left: 0 },
                showLoginP: false,
                showLogin: false,
                nreAnnulla: null,
                idAnnulla: 0,
                typeAnnulla: "",
                tooltipMapF: {},
                loadedTooltipsF: {},                            
                tooltipMap: {},
                loadedTooltips: {}, 
                hoveredId: null,  
                countPrescriptions: 0,
                filters: {
                    split_: function (st, rep) {
                        let result = st.split(rep)
                        result = result[0]
                        return result;
                    },
                    split__: function (st, rep) {
                        let result = st.split(rep)
                        result = result[1]
                        return result;
                    },                      
                },            
                parsedDataRicetta: [],
                ricetta_data_pdf: {
                    patient: {
                        name: '',
                        address: '',
                        cap: '',
                        city: '',
                        province: '',
                    },
                    prescriptions: [],
                    prescriptionInfo: {
                        type: '',
                        altro: '—',
                        priority: '',
                        confezioni: 2,
                        tipo: '',
                        date: '',
                        nre:  ''
                    },
                    doctor: {
                        name: '',
                        cf: '',
                    },
                    data: {
                        box1: '',
                        box2: '',
                        field9: '',
                        exemption: '',
                        siglaProvincia: '',
                        codiceASL: '',
                        disposizioniRegionali: '',
                        qd: '',
                        authCode: '',
                    }                   
                },
                parsedDataRicettaF: [],
                ricetta_data_pdf_f: {
                    patient: {
                        name: '',
                        address: '',
                        cap: '',
                        city: '',
                        province: '',
                    },
                    prescriptions: [],
                    prescriptionInfo: {
                        type: '',
                        altro: '—',
                        priority: '',
                        confezioni: 2,
                        tipo: '',
                        date: '',
                        nre:  ''
                    },
                    doctor: {
                        name: '',
                        cf: '',
                    },
                    data: {
                        box1: '',
                        box2: '',
                        field9: '',
                        exemption: '',
                        siglaProvincia: '',
                        codiceASL: '',
                        disposizioniRegionali: '',
                        qd: '',
                        authCode: '',
                    }                   
                },                
                pdf: {
                    config: {

                        margin: 10,

                        jsPDF: {
                            //unit: 'in',
                            format: 'a4',
                            orientation: 'portrait'
                        },

                        filename: "ricetta"

                    }
                },                
                open_recapiti: false,
                open_caregiver: false,
                form: {
                    DB: {
                        name:       null,
                        surname:    null,
                        CF:         null,
                        date_birth: null,
                        phone:      null,
                        email:      null,
                        sex:        null,
                        address:    null,
                        note:       "",
                        namecg:     null,
                        surnamecg:  null,
                        phonecg:    null,
                        emailcg:    null,                                           
                    },
                    recapiti: {
                        telefonico: {
                            phone:   null,
                            phonecg: null
                        },
                        elettronico: {
                            email:   null,
                            emailcg: null      
                        }
                    },
                    confirm: {
                        phone: null,
                        email: null,
                        phonecg: null,
                        emailcg: null                       
                    }
                },
                validation: {
                    ko: false,
                    update: {
                        patient: {
                            ko: false,
                            ok: false
                        }
                    }
                },
                loaders: {
                    reading:    true,
                    suspending: false,
                    deleting:   false,

                    updating: {
                        phone:   false,
                        email:   false,
                        phonecg: false,
                        emailcg: false,                       
                        patient: false
                    }
                    
                },
                patients_pathologies: [],
                appointments: [],
                therapies: {
                    DB: []
                },
                ricette: [],
                ricette_farmaceutiche: []
            }
        },
        validations() {
            return {
                form: {
                    recapiti: {
                        telefonico: {
                            phone: {
                                required,
                                equalOriginal() {
                                    return this.form.DB.phone == this.form.recapiti.telefonico.phone
                                }
                            },
                            phonecg: {
                                required,
                                equalOriginal() {
                                    return this.form.DB.phonecg == this.form.recapiti.telefonico.phonecg
                                }
                            }                           
                        },
                        elettronico: {
                            email: {
                                required,
                                equalOriginal() {
                                    return this.form.DB.email == this.form.recapiti.elettronico.email
                                }
                            },
                            emailcg: {
                                required,
                                equalOriginal() {
                                    return this.form.DB.emailcg == this.form.recapiti.elettronico.emailcg
                                }
                            }                           
                        }
                    },
                    confirm: {
                        phone: {
                            required,
                            equalsPhone() {
                                return this.form.recapiti.telefonico.phone == this.form.confirm.phone
                            }
                        },
                        email: {
                            required,
                            equalsEmail() {
                                return this.form.recapiti.elettronico.email == this.form.confirm.email
                            }
                        },
                        phonecg: {
                            required,
                            equalsPhone() {
                                return this.form.recapiti.telefonico.phonecg == this.form.confirm.phonecg
                            }
                        },
                        emailcg: {
                            required,
                            equalsEmail() {
                                return this.form.recapiti.elettronico.emailcg == this.form.confirm.emailcg
                            }
                        }                       
                    },
                    DB: {
                        name: {
                            required
                        },
                        surname: {
                            required
                        },
                        note: {
                            maxLength: maxLength(1000)
                        },
                        date_birth: {},
                        sex: {},
                        address: {},
                        namecg: {},
                        surnamecg: {}                
                    }
                }
            }
        },
        components: {
            VueHtml2pdf,
            NreBarcode,
            FiscalCodeBarcode,
            JsonViewer
        },              
        methods: {
            openModalViewRecup(nre) {
                this.currentNre = nre
                this.viewRecup(nre)
            },        
            hasCur(ricetta) {
                try {
                    const items = JSON.parse(ricetta.data_send)
                    return items.some(item =>
                        item.data.some(d => this.curTargets.includes(d.codice_cur))
                    )
                } catch (e) {
                    return false
                }
            },          
            confirmSend(ricetta, type) {
                this.showPopup = true
                this.ricettaObj = ricetta
                this.typeRicetta = type
                /*if (confirm('Sei sicuro di voler inviare questa ricetta al Recup?')) {
                    this.sendRecup(ricetta)
                } else {
                    console.log('Azione annullata');
                }*/
            }, 
            okSendRecup(){
                this.sendRecup(this.ricettaObj, this.typeRicetta)
            }, 
            koSendRecup() {
                this.showPopup = false;
            },      
            toggleLogin(type, nre, id) {             
                this.showLogin = !this.showLogin;    
                this.nreAnnulla = nre   
                this.idAnnulla = id
                this.typeAnnulla = type  
                this.$nextTick(() => {
                    if (this.showLogin && event) {
                        const rect = event.target.getBoundingClientRect();

                        this.popupPosition = {
                            top: rect.top + window.scrollY -100,
                            left: rect.right + window.scrollX - 150 // 10px a destra
                        };
                    }
                });     
            },
            submitLogin(event) {
                
                if (this.username && this.password) {
                    this.showLogin = false;
                    if (this.rememberMe) {
                        localStorage.setItem('rememberedLogin', 'true');
                        localStorage.setItem('username', this.username);
                        localStorage.setItem('password', this.password);
                    } else {
                        localStorage.removeItem('rememberedLogin');
                        localStorage.removeItem('username');
                        localStorage.removeItem('password');
                    }
                    if(this.typeAnnulla == "F"){
                        this.backRicettaF(this.nreAnnulla, this.idAnnulla, this.username, this.password)
                    } else if(this.typeAnnulla == "P") {
                        this.backRicetta(this.nreAnnulla, this.idAnnulla, this.username, this.password)
                    } else {
                        return false
                    }
                    
                    //this.sendRicettaServer(1, this.username, this.password);
                } else {
                    event.preventDefault();
                }
            },        
            async handleMouseEnter(id) {
                const elRef = this.$refs[`tooltipEl-${id}`]
                const el = Array.isArray(elRef) ? elRef[0] : elRef
                if (!el) return

                if (this.tooltipMap[id]) return

                el.removeAttribute('title')

                if (this.loadedTooltips[id]) return
                this.loadedTooltips[id] = true

                const stato = await this.showTooltipStato(id)
                if (!stato) return

                this.$set(this.tooltipMap, id, stato)

                this.$nextTick(() => {
                    el.setAttribute('title', stato)
                })
            },            
            async showTooltipStato(id) {
                const CF = this.$route.params.CF;
                try {

                    const patient = await this.axios.get(`user/ricetta/read/detail/${id}/${CF}`, {
                        headers:{
                            Authorization: `bearer ${this.$store.state.auth.token}`
                        }
                    })

                    const ricetta = patient.data

                    const jsonData = JSON.parse(ricetta.data_send)


                    return jsonData[0].header[0].statoRicetta

                } catch(e) {

                    this.$toast.open({
                        message: `Si è verificato un problema, ${e.response ? e.response.data.msg : 'verifica la tua connessione.'}` ,
                        type:    `error`
                    })
                    return null

                }

            },
            async handleMouseEnterF(id) {
                const elRef = this.$refs[`tooltipEl-${id}`]
                const el = Array.isArray(elRef) ? elRef[0] : elRef
                if (!el) return

                if (this.tooltipMapF[id]) return

                el.removeAttribute('title')

                if (this.loadedTooltipsF[id]) return
                this.loadedTooltipsF[id] = true

                const stato = await this.showTooltipStatoF(id)
                if (!stato) return

                this.$set(this.tooltipMapF, id, stato)

                this.$nextTick(() => {
                    el.setAttribute('title', stato)
                })
            },            
            async showTooltipStatoF(id) {
                const CF = this.$route.params.CF;
                try {

                    const patient = await this.axios.get(`user/ricetta/read/detail_f/${id}/${CF}`, {
                        headers:{
                            Authorization: `bearer ${this.$store.state.auth.token}`
                        }
                    })

                    const ricetta = patient.data

                    const jsonData = JSON.parse(ricetta.data_send)


                    return jsonData[0].header[0].statoRicetta

                } catch(e) {

                    this.$toast.open({
                        message: `Si è verificato un problema, ${e.response ? e.response.data.msg : 'verifica la tua connessione.'}` ,
                        type:    `error`
                    })
                    return null

                }

            },

            async cloneRicetta(id) {

                try {

                    const ricetta = await this.axios.post(`user/ricetta/clone`, {id}, {
                        headers:{
                            Authorization: `bearer ${this.$store.state.auth.token}`
                        }
                    })

                    this.$toast.open({
                        message: ricetta.data.msg,
                        type:   `success`
                    })  
                    
                    this.$router.go(this.$router.currentRoute)                    
                }
                catch(e) {

                    this.$toast.open({
                        message: `Si è verificato un problema, ${e.response ? e.response.data.msg : 'verifica la tua connessione.'}` ,
                        type:    `error`
                    })

                }

            }, 
            
            async cloneRicettaF(id) {

                try {

                    const ricetta = await this.axios.post(`user/ricetta/clone_f`, {id}, {
                        headers:{
                            Authorization: `bearer ${this.$store.state.auth.token}`
                        }
                    })

                    this.$toast.open({
                        message: ricetta.data.msg,
                        type:   `success`
                    })  
                    
                    this.$router.go(this.$router.currentRoute)                    
                }
                catch(e) {

                    this.$toast.open({
                        message: `Si è verificato un problema, ${e.response ? e.response.data.msg : 'verifica la tua connessione.'}` ,
                        type:    `error`
                    })
                }
            }, 
            async sendRecup(id) {
                this.showPopup = false;
                this.loaders.reading = true
                try {
                    const ricetta = await this.axios.post(`user/ricetta/send_recup`, {id}, {
                        headers:{
                            Authorization: `bearer ${this.$store.state.auth.token}`
                        }
                    })

                    this.$toast.open({
                        message: ricetta.data.msg,
                        type:   `success`
                    })  

                    this.loaders.reading = false
                    
                    this.$router.go(this.$router.currentRoute)                    
                }
                catch(e) {

                    this.loaders.reading = false                 

                    this.$toast.open({
                        message: `Si è verificato un problema, ${e.response ? e.response.data.msg : 'verifica la tua connessione.'}` ,
                        type:    `error`
                    })

                     this.$router.go(this.$router.currentRoute)   
                }
            }, 
            async viewRecup(nre) {
                try {
                    const ricetta = await this.axios.post(`user/ricetta/view_recup`, {nre}, {
                        headers:{
                            Authorization: `bearer ${this.$store.state.auth.token}`
                        }
                    })

                    this.jsonRecup = ricetta;

                    this.$bvModal.show('modal_view_recup');


                } catch (err) {
                    console.error("Errore:", err)
                    this.$toast?.open({
                    message: 'Errore durante il recupero',
                    type: 'error'
                    })
                }            
            },             

            createPDF(ref) {
                this.$refs[ref].generatePdf()   
            },          
            async readRicetta(id, CF) {
                try {

                    this.parsedDataRicetta = []

                    const patient = await this.axios.get(`user/ricetta/read/detail/${id}/${CF}`, {
                        headers:{
                            Authorization: `bearer ${this.$store.state.auth.token}`
                        }
                    })

                    const ricetta = patient.data

                    const jsonData = JSON.parse(ricetta.data_send)


                    for(const arr of jsonData) {
                        if(arr.header[0].sent == 1){
                            this.parsedDataRicetta.push(arr)
                        }  
                    } 

                    this.ricetta_data_pdf.doctor.name = ricetta.user.surname + " " + ricetta.user.name
                    this.ricetta_data_pdf.doctor.cf = ricetta.cfMedico

                    //const jsonOtherData = JSON.parse(ricetta.other_data)    
                    

                    //const arrayData = jsonData[0].data[0]
                    const arrayOtherData = jsonData[0].header[0]
                    const arrayPrescriptions = jsonData[0].data

                    this.ricetta_data_pdf.prescriptionInfo.priority = jsonData[0].data[0].priorita

                    for(const prescription of arrayPrescriptions) {

                        this.ricetta_data_pdf.prescriptions.push({
                            details: prescription.codice_prestazione + " (" + prescription.codice_cur + ") " + prescription.descrizione_prestazione,
                            qta: prescription.quantita,
                            nota: prescription.note
                        })
                    }   

                    this.ricetta_data_pdf.prescriptionInfo.type = arrayOtherData.indicazione_prescrizione
                    this.ricetta_data_pdf.prescriptionInfo.altro = '—'
                    this.ricetta_data_pdf.prescriptionInfo.nre = arrayOtherData.nre  


                    

                    this.ricetta_data_pdf.patient.name = ricetta.patient.surname + " " + ricetta.patient.name
                    this.ricetta_data_pdf.patient.address = ricetta.patient.address
                    this.ricetta_data_pdf.patient.cap = ""
                    this.ricetta_data_pdf.patient.city = ""
                    this.ricetta_data_pdf.patient.province = ""
                    

                    this.createPDF("html2PdfRicetta")
                }
                catch(e) {

                    this.$toast.open({
                        message: `Si è verificato un problema, ${e.response ? e.response.data.msg : 'verifica la tua connessione.'}` ,
                        type:    `error`
                    })

                }

            },   
            async readRicettaF(id, CF) {
                try {

                    this.parsedDataRicettaF = []

                    const patient = await this.axios.get(`user/ricetta/read/detail_f/${id}/${CF}`, {
                        headers:{
                            Authorization: `bearer ${this.$store.state.auth.token}`
                        }
                    })

                    const ricetta = patient.data

                    const jsonData = JSON.parse(ricetta.data_send)

                    for(const arr of jsonData) {
                        if(arr.header[0].sent == 1){
                            this.parsedDataRicettaF.push(arr)
                        }                          
                    } 

                    this.ricetta_data_pdf_f.doctor.name = ricetta.user.surname + " " + ricetta.user.name
                    this.ricetta_data_pdf_f.doctor.cf = ricetta.cfMedico

                    //const jsonOtherData = JSON.parse(ricetta.other_data)    
                    

                    //const arrayData = jsonData[0].data[0]
                    const arrayOtherData = jsonData[0].header[0]
                    const arrayPrescriptions = jsonData[0].data

                    this.ricetta_data_pdf_f.prescriptionInfo.priority = jsonData[0].data[0].priorita

                    for(const prescription of arrayPrescriptions) {

                        this.ricetta_data_pdf_f.prescriptions.push({
                            details: prescription.codice_prestazione + " " + prescription.descrizione_prestazione,
                            qta: prescription.quantita,
                            nota: prescription.note
                        })
                    }   

                    this.ricetta_data_pdf_f.prescriptionInfo.type = arrayOtherData.indicazione_prescrizione
                    this.ricetta_data_pdf_f.prescriptionInfo.altro = '—'
                    this.ricetta_data_pdf_f.prescriptionInfo.nre = arrayOtherData.nre  


                    

                    this.ricetta_data_pdf_f.patient.name = ricetta.patient.surname + " " + ricetta.patient.name
                    this.ricetta_data_pdf_f.patient.address = ricetta.patient.address
                    this.ricetta_data_pdf_f.patient.cap = ""
                    this.ricetta_data_pdf_f.patient.city = ""
                    this.ricetta_data_pdf_f.patient.province = ""
                    

                    this.createPDF("html2PdfRicettaF")
                }
                catch(e) {

                    this.$toast.open({
                        message: `Si è verificato un problema, ${e.response ? e.response.data.msg : 'verifica la tua connessione.'}` ,
                        type:    `error`
                    })

                }

            },                                       
            async removeRicetta(id){
                try {

                    const ricetta = await this.axios.post(`user/ricetta/delete`, {id}, {
                        headers:{
                            Authorization: `bearer ${this.$store.state.auth.token}`
                        }
                    })

                    this.$toast.open({
                        message: ricetta.data.msg,
                        type:   `success`
                    })  
                    
                    this.$router.go(this.$router.currentRoute)

                }
                catch(e) {

                    this.$toast.open({
                        message: "Errore di connessione con il server",
                        type: "error"
                    })

                }                
            },
             async removeRicettaF(id){
                try {

                    const ricetta = await this.axios.post(`user/ricetta/delete_f`, {id}, {
                        headers:{
                            Authorization: `bearer ${this.$store.state.auth.token}`
                        }
                    })

                    this.$toast.open({
                        message: ricetta.data.msg,
                        type:   `success`
                    })  
                    
                    this.$router.go(this.$router.currentRoute)

                }
                catch(e) {

                    this.$toast.open({
                        message: "Errore di connessione con il server",
                        type: "error"
                    })

                }                
            },           
            async backRicetta(nre, id, username, password) {

                this.loaders.creating = true
                this.validation.ko    = false
                this.form.CF          = this.$route.params.CF

                try {
                    const ricetta = await this.axios.post(`user/ricetta/annulla`, {nre, id, username, password}, {
                        headers:{
                            Authorization: `bearer ${this.$store.state.auth.token}`
                        }
                    })


                    this.$toast.open({
                        message: ricetta.data.msg,
                        type:   `success`
                    })

                    this.$router.go(this.$router.currentRoute)
                }catch(e) {

                    const message = e.response.data.msg

                    this.$toast.open({
                        message,
                        type: `error`
                    })

                }

            }, 
            async backRicettaF(nre, id, username, password) {

                this.loaders.creating = true
                this.validation.ko    = false
                this.form.CF          = this.$route.params.CF

                try {
                    const ricetta = await this.axios.post(`user/ricetta/annulla_f`, {nre, id, username, password}, {
                        headers:{
                            Authorization: `bearer ${this.$store.state.auth.token}`
                        }
                    })

                    this.$toast.open({
                        message: ricetta.data.msg,
                        type:   `success`
                    })

                    this.$router.go(this.$router.currentRoute)
                }catch(e) {

                    const message = e.response.data.msg

                    this.$toast.open({
                        message,
                        type: `error`
                    })

                }

            },                      
            async readTherapies() {
                try {

                    this.therapies.DB = (
                        await this.axios.get(`user/therapies/read/actives`, {
                            headers:{
                                Authorization: `bearer ${this.$store.state.auth.token}`
                            }
                        })
                    ).data

                }
                catch(e) {

                    this.$toast.open({
                        message: "Errore di connessione con il server",
                        type: "error"
                    })

                }
            },            
            async updatePhone() {

                this.loaders.updating.phone = true

                const {
                    phone
                } = this.form.recapiti.telefonico
                const {
                    CF
                } = this.$route.params

                try {

                    const patient = await this.axios.post(`user/patients/update/phone`, {
                        phone,
                        CF
                    },
                    {
                        headers:{
                            Authorization: `bearer ${this.$store.state.auth.token}`
                        }
                    })

                    this.$toast.open({
                        message: patient.data.msg,
                        type:   `success`
                    })
                    
                }
                catch(e) {

                    this.$toast.open({
                        message: e.response.data.msg,
                        type:   `error`
                    })

                }
                finally {
                    this.loaders.updating.phone = false
                }
                
            },

            async updatePhoneCG() {

                this.loaders.updating.phonecg = true

                const {
                    phonecg
                } = this.form.recapiti.telefonico
                const {
                    CF
                } = this.$route.params

                try {

                    const patient = await this.axios.post(`user/patients/update/phonecg`, {
                        phonecg,
                        CF
                    },
                    {
                        headers:{
                            Authorization: `bearer ${this.$store.state.auth.token}`
                        }
                    })

                    this.$toast.open({
                        message: patient.data.msg,
                        type:   `success`
                    })
                    
                }
                catch(e) {

                    this.$toast.open({
                        message: e.response.data.msg,
                        type:   `error`
                    })

                }
                finally {
                    this.loaders.updating.phonecg = false
                }

            },           
            async updateEmail() {

                this.loaders.updating.email = true

                const {
                    email
                } = this.form.recapiti.elettronico
                const {
                    CF
                } = this.$route.params

                try {

                    const patient = await this.axios.post(`user/patients/update/email`, {
                        email,
                        CF
                    },
                    {
                        headers:{
                            Authorization: `bearer ${this.$store.state.auth.token}`
                        }
                    })

                    this.$toast.open({
                        message: patient.data.msg,
                        type:   `success`
                    })
                    
                }
                catch(e) {

                    this.$toast.open({
                        message: e.response.data.msg,
                        type:   `error`
                    })

                }
                finally {
                    this.loaders.updating.email = false
                }
                
            },
            async updateEmailCG() {

                this.loaders.updating.emailcg = true

                const {
                    emailcg
                } = this.form.recapiti.elettronico
                const {
                    CF
                } = this.$route.params

                try {

                    const patient = await this.axios.post(`user/patients/update/emailcg`, {
                        emailcg,
                        CF
                    },
                    {
                        headers:{
                            Authorization: `bearer ${this.$store.state.auth.token}`
                        }
                    })

                    this.$toast.open({
                        message: patient.data.msg,
                        type:   `success`
                    })
                    
                }
                catch(e) {

                    this.$toast.open({
                        message: e.response.data.msg,
                        type:   `error`
                    })

                }
                finally {
                    this.loaders.updating.emailcg = false
                }

            },           
            async ricerca_asur() {

                // Uppercase
                const CF = this.$route.params.CF.toUpperCase()

                const {
                    patient
                } = (
                    await this.axios.post(`user/patients/search/asur`, {CF}, {
                        headers:{
                            Authorization: `bearer ${this.$store.state.auth.token}`
                        }
                    })
                ).data

                //console.log(patient);

                const decesso = document.getElementById('decesso');

                decesso.style.display = "none";

                if(patient.decesso != ""){
                    const message = "Paziente deceduto"

                    
                    decesso.style.display = "block";

                    this.$toast.open({
                        message: message,
                        type: `error`
                    })

                    return false
                }

            },                          
            async readPatient() {
                this.ricerca_asur()

                try {

                    let patient = await this.axios.get(`user/patients/read/detail/${this.$route.params.CF}`, {
                        headers:{
                            Authorization: `bearer ${this.$store.state.auth.token}`
                        }
                    })

                    patient.data.date_birth = moment(patient.data.date_birth).format("YYYY-MM-DD")
                    this.form.DB            = patient.data

                    if(this.form.DB.note == null) this.form.DB.note = ""

                    if(patient.data.patients_pathologies) { 

                        // Popoliamo array delle terapie seguite
                        this.patients_pathologies = patient.data.patients_pathologies

                        // Popoliamo array degli appuntamenti estrapolandoli dalle terapie seguite
                        for(let patient_pathology of patient.data.patients_pathologies) {  
                            
                            for(let appointment of patient_pathology.appointment) {
                                // Aggiungiamo il titolo della patologia da visualizzare nella card
                                appointment.pathology = patient_pathology.pathology.title
                                this.appointments.push(appointment)
                                //console.log(appointment)
                            }                          
                        }

                    }

                    if(patient.data.ricetta) { 
                        this.ricette = patient.data.ricetta
                        this.ricette_farmaceutiche = patient.data.ricetta_farmaceutica
                    }                   
                }
                catch(e) {

                    this.$toast.open({
                        message: e.response.data.msg,
                        type:   `error`
                    })

                    this.$router.push(`/user/pazienti`)

                }
                finally {
                    this.loaders.reading = false
                }

            },
            async suspendPatient() {

                this.loaders.suspending = true

                try {

                    const res = await this.axios.get(`user/patients/suspend/${this.$route.params.CF}`, {
                        headers:{
                            Authorization: `bearer ${this.$store.state.auth.token}`
                        }
                    })

                    this.$toast.open({
                        message: res.data.msg,
                        type:   'success'
                    })

                    this.form.DB.state = !this.form.DB.state
                    
                }
                catch(e) {

                    this.$toast.open({
                        message: e.response.data.msg,
                        type:   'error'
                    })

                }
                finally {
                    this.loaders.suspending = false
                }

            },
            async updatePatient() {

                // Attivazione loader
                this.loaders.updating.patient = true

                // Reset form

                this.validation.update.patient.ok = false
                this.validation.update.patient.ko = false

                try {

                    const patient = await this.axios.post(`user/patients/update`, this.form.DB, {
                        headers:{
                            Authorization: `bearer ${this.$store.state.auth.token}`
                        }
                    })

                    const message = patient.data.msg

                    this.$toast.open({
                        message,
                        type:   `success`
                    })

                    this.validation.update.patient.ok = message
                    
                }
                catch(e) {

                    const message = e.response.data.msg

                    this.$toast.open({
                        message,
                        type:   `error`
                    })

                    this.validation.update.patient.ko = message

                }
                finally {
                    this.loaders.updating.patient = false                
                }

            },
            async delete_patient() {

                this.loaders.deleting = true

                try {

                    const res = await this.axios.delete(`user/patients/${this.form.DB.CF}`, {
                        headers:{
                            Authorization: `bearer ${this.$store.state.auth.token}`
                        }
                    })

                    this.$toast.open({
                        message: res.data.msg,
                        type:   `success`
                    })

                    this.$router.push(`/user/pazienti`)
                    
                }
                catch(e) {

                    this.$toast.open({
                        message: e.response.data.msg,
                        type:   'error'
                    })

                    this.loaders.deleting = false

                }

            },
            functionDisabled(id_function, action) {

                for(let sFunction of store.getters.softwareFunctions) {
                    if(sFunction.id_software_functions == id_function && !sFunction[action]) {
                        return true
                    }
                    else if(sFunction.id_software_functions == id_function && sFunction[action]) {
                        return false
                    }
                }

                return true

            }
        },    
        mounted() {
            this.readTherapies()
            this.readPatient()                                
        }
    }

</script>